import {SET_FULLTEXT_THEMEN, SET_FULLTEXT_REFERENTEN, SET_EINSATZGEBIET, RESET} from '../../types/themenFilters'

function shouldChangeStateForFulltext(phrase) {
    return phrase.length > 3;

}

export function setFulltextThemenSearch(phrase) {
    if (shouldChangeStateForFulltext(phrase)) {
        return {
            type: SET_FULLTEXT_THEMEN,
            data: phrase
        }
    }
    return {
        type: SET_FULLTEXT_THEMEN,
        data: null
    }
}

export function setFulltextReferentenSearch(phrase) {
    if (shouldChangeStateForFulltext(phrase)) {
        return {
            type: SET_FULLTEXT_REFERENTEN,
            data: phrase
        }
    }
    return {
        type: SET_FULLTEXT_REFERENTEN,
        data: null
    }
}

export function setEinsatzgebietSearch(phrase) {
    return {
        type: SET_EINSATZGEBIET,
        data: phrase
    }
}

export function resetFilters() {
    return {
        type: RESET
    }
}



// WEBPACK FOOTER //
// ./src/actions/referenten/filters.js